import type {
  ConvertibleUnit,
  FormatOptions,
  Unit,
} from '@dynatrace-sdk/units';

import type { SingleValueUnit } from '../../core/components/single-value-renderer/types/single-value-base-props.js';
import type { Formatter } from '../../core/types/formatter.js';

/**
 * Slot props for the value component within SingleValueGrid.
 * @public
 */
export interface SingleValueGridValueProps {
  /** Accessor function to retrieve the data for the value. */
  dataAccessor?: string;
  /** Formatter options for formatting the value. */
  formatter?: Formatter | FormatOptions<Unit, ConvertibleUnit>;
  /** Accessor function to retrieve the formatter options for the value. */
  formatterAccessor?: string;
  /** Unit for the value. */
  unit?: SingleValueUnit;
  /** Accessor function to retrieve the unit for the value. */
  unitAccessor?: string;
}
/**
 * @public
 */
export const Value = (props: SingleValueGridValueProps) => null;

Value['displayName'] = 'SingleValueGrid.Value';
